<template>
    <div class="form-group">
        <h3>Select shipping method</h3>
        <div class="row" v-if="shippingMethods.length > 0 && !isLoadingShippingMethods">
            <div class="col-lg-12">
                <div class="form-control">
                    <v-select :options="shippingMethods" title="Shipping method"
                              placeholder="Select Shipping Method"
                              :readonly="isLoadingShippingMethods"
                              :disabled="isLoadingShippingMethods"
                              name="shippingMethod"
                              id="shippingMethod"
                              :clearable="false"
                              v-validate="'required'"
                              data-vv-as="Shipping Method"
                              v-model="selectedModel"
                              aria-label="Select Shipping method"
                    >
                        <template #search="{ attributes, events }">
                            <input
                                class="vs__search"
                                v-bind="attributes"
                                v-on="events"
                                aria-labelledby="shippingMethod"
                            ></input>
                        </template>
                    </v-select>
                    <span class="validation-errors"
                          v-for="error in errors.collect('shippingMethod')">{{ error }}</span>
                </div>
            </div>
        </div>
        <div class="alert alert-info" v-if="isLoadingShippingMethods" v-loading="true">
            Loading available shipping methods...
        </div>
        <div class="alert alert-warning" v-if="!isLoadingShippingMethods && shippingMethods.length === 0">
            Please enter the correct address information
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import {mapActions} from 'vuex';

    export default Vue.extend({
        name: "shippingMethods",
        computed: {
            isLoadingShippingMethods() {
                return this.$store.state.checkout.isLoadingShippingMethods || false;
            },
            selectedModel: {
                get() {
                    return this.$store.state.shippingMethods.selected_shipping_method;
                },
                set(p) {
                    this.$store.dispatch('shippingMethods/setSelectedShippingMethod', p)
                },
            },
            shippingMethods() {
                return this.$store.state.shippingMethods.shipping_methods;
            }
        },
        watch: {
            shippingMethods(value) {
                if (value.length > 0 && !this.selectedModel) {
                    this.selectedModel = value[0];
                    this.setSelectedShippingMethod(value[0]);
                }
            }
        },
        methods: {
            ...mapActions('shippingMethods', [
                'setSelectedShippingMethod'
            ])
        }
    });
</script>
